import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { success, failure } from '~/redux/actions/snackbar-actions';
import { cancelOrderByAdmin } from '~/redux/actions/admin-orders-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import { OrderCancelCIcon } from '~/assets/images';

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedOrder, getAdminOrders } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(cancelOrderByAdmin(selectedOrder));
      if (response.status === 200) {
        getAdminOrders();
        dispatch(success(response.data.message));
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header: MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.HEADING,
        message: MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.TITLE,
        icon: OrderCancelCIcon,
        handleOk: onSubmit,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default ActionModal;
